/** Stockage du choix cookies (localStorage). Révoquer = supprimer cette clé ou passer par « Gérer mes cookies ». */
export const COOKIE_CONSENT_STORAGE_KEY = "epp_cookie_consent_v1";

export const CONSENT_VERSION = 1;

/** @returns {{ v: number, necessary: true, analytics: boolean, marketing: boolean, ts: string | null }} */
export function defaultConsentRecord() {
  return {
    v: CONSENT_VERSION,
    necessary: true,
    analytics: false,
    marketing: false,
    ts: null,
  };
}

/**
 * @param {string | null} raw
 * @returns {{ v: number, necessary: true, analytics: boolean, marketing: boolean, ts: string | null } | null}
 */
export function parseConsentRecord(raw) {
  if (!raw) return null;
  try {
    const o = JSON.parse(raw);
    if (o.v !== CONSENT_VERSION || typeof o.analytics !== "boolean" || typeof o.marketing !== "boolean") {
      return null;
    }
    return {
      v: CONSENT_VERSION,
      necessary: true,
      analytics: o.analytics,
      marketing: o.marketing,
      ts: typeof o.ts === "string" ? o.ts : null,
    };
  } catch {
    return null;
  }
}
